import React from 'react';
import './ButtonSpinner.scss';

export default function ButtonSpinner () {
    return (
        <span className="button-spinner-container">
            <span className="button-spinner-busy"></span>
        </span>
    );
};